import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { EmailMarginComponent } from '../email-margin/email-margin.component';
import { EmailNewBadgeComponent } from '../email-new-badge/email-new-badge.component';
import { EmailTextComponent } from '../email-text/email-text.component';

export interface GDPRReport {
  title: string;
  period?: string;
  items: GDPRReportItem[];
}

export interface GDPRReportItem {
  new: boolean;
  new_label: string;
  title: string;
  value: number | string;
}

@Component({
  selector: 'email-gdpr-reports',
  styleUrls: ['./email-gdpr-reports.component.less'],
  template: `
    <ng-container *mailgunFor="let report of reports">
      <table cellspacing="0" cellpadding="0" class="gdpr-reports-container">
        <tr>
          <td colspan="3" width="100%">
            <table cellspacing="0" cellpadding="0">
              <tr>
                <th class="report-title-head-cell">
                  <email-text [contents]="report.title" presetName="header" size="small" />
                </th>
                <th class="report-value-head-cell">
                  <ng-container *mailgunIf="report.period">
                    <email-text [contents]="report.period" size="small" />
                  </ng-container>
                </th>
              </tr>
            </table>
            <email-margin [height]="12" />
          </td>
        </tr>

        <ng-container *mailgunFor="let item of report.items">
          <tr>
            <td class="report-title-cell" align="left">
              <table cellpadding="0" cellspacing="0" class="gdpr-report">
                <tr>
                  <ng-container *mailgunIf="item.new">
                    <td class="new-badge-cell">
                      <email-margin [height]="3" />
                      <email-new-badge [label]="item.new_label" />
                    </td>
                    <td width="8" style="min-width: 8px;max-width: 8px;">&nbsp;</td>
                  </ng-container>
                  <td align="left" width="100%">
                    <email-text
                      [contents]="item.title"
                      size="small"
                      vAlign="middle"
                      className="report-title-text"
                    />
                  </td>
                </tr>
              </table>
            </td>
            <td width="4" class="report-title-value-space-cell">&nbsp;</td>
            <td nowrap class="report-value-cell">
              <email-text
                [contents]="item.value"
                [bold]="true"
                className="v-align-middle report-value-text"
              />
            </td>
          </tr>
        </ng-container>
        <tr>
          <td colspan="3">
            <email-margin [height]="12" />
          </td>
        </tr>
      </table>
    </ng-container>
  `,
  hostDirectives: [SsrMarkToUnwrapDirective],
  // eslint-disable-next-line @angular-eslint/use-component-view-encapsulation
  encapsulation: ViewEncapsulation.None,
  imports: [
    EmailTextComponent,
    EmailMarginComponent,
    EmailNewBadgeComponent,
    EmailMailgunEachDirective,
    EmailMailgunEachDirective,
    EmailMailgunIfDirective,
    EmailMailgunIfDirective,
  ],
})
export class EmailGdprReportsComponent {
  @Input({ required: true }) public reports: WrappedValue<GDPRReport[]>;
}
